"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _styles = require("@material-ui/styles");
var _logoSquare = require("@catalytic/catalytic-icons/lib/icons/logo-square.svg");
var useStyles = (0, _styles.makeStyles)({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1.5rem',
    height: '1.5rem'
  },
  icon: {
    fontSize: '1.625rem'
  }
});
/*:: type Props = {
  to: string
};*/
var NavLogo = function NavLogo(_ref /*:: */) {
  var to = _ref /*:: */.to;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    className: classes.root,
    to: to
  }, /*#__PURE__*/_react.default.createElement(_logoSquare.ReactComponent, {
    className: classes.icon
  }));
};
NavLogo.displayName = 'NavLogo';
NavLogo.defaultProps = {
  to: '/'
};
var _default = exports.default = NavLogo;
//# sourceMappingURL=NavLogo.js.map